import selfHtml from './s940-select_rcpt.html' with { type: 'text' };;
import templateHtml from './t01-avatars.html' with { type: 'text' };

import { db_ExtPub, MsgComposeModule } from "../AppState.js";
import { get_pub_key } from "../crypt_helper.js";
import { getUserAvatar, styleAvatar } from "../utils.js";

var lstEndorseFieldset
var listgroup_contacts
var listgroup_item_master
var is_access_method_single
var is_access_method_quorum
var quorumSlider
var quorumNumber

var root

export async function init(module_root) {

    module_root.innerHTML = selfHtml;
    root = module_root;

    $e(root).getEl("templates_container").innerHTML = templateHtml;
    lstEndorseFieldset = $e(root).getEl("lstEndorseFieldset");

    listgroup_contacts = root.querySelector(".list-group");
    // listgroup_item_master = root.querySelector(".list-group-item").cloneNode(true);

    quorumSlider = root.querySelector("#quorumSlider");
    quorumNumber = root.querySelector(".quorumNumber");

    quorumSlider.addEventListener('change', () => {
        quorumNumber.innerText = quorumSlider.value;
        MsgComposeModule.set_threshold(quorumSlider.value);
    })

}
// -------------------------------------------------------------------------------------------
export async function refresh(access_method, selected_rcpt) {

    is_access_method_single = access_method == "access_method_single";
    is_access_method_quorum = access_method == "access_method_quorum";

    show_hide_quorum_panel(selected_rcpt.length);

    const my_pub_key = await get_pub_key();

    const contacts = await db_ExtPub.keys();

    // To sort the main array by username it is needed to build array key/names 
    var names = {};

    for (const key of contacts) {
        const user = await db_ExtPub.get(key);
        names[key] = user.userID[0];
    }

    if (Object.keys(names).length > 1)
        root.querySelector(".contacts_solo").classList.add("d-none")
    else
        root.querySelector(".contacts_solo").classList.remove("d-none")

    contacts.sort((a, b) =>
        names[a].localeCompare(names[b])
    );

    if (contacts.length)
        lstEndorseFieldset.innerHTML = '';
    else
        return lstEndorseFieldset.innerHTML = "No items";

    const tpl = $e(root).getEl("tpl-endorse-row");

    for (const key of contacts) {
        const contact = await db_ExtPub.get(key);
        const is_self = contact.fingerprint == my_pub_key.myKeyPairFingerprint
        const str_is_self = is_self ? " (yourself)" : "";
        const is_selected = selected_rcpt.includes(contact.publicKey) ? true : false;
        const node = tpl.content.cloneNode(true);
        const label = node.querySelector("label");
        const checkbox = node.querySelector("input");

        if (is_self)
            $e(node).getEl("myself").classList.remove("visually-hidden");
        else
            $e(node).getEl("myself").classList.add("visually-hidden");

        // hide the checkbox 
        if (is_access_method_single)
            node.querySelector("input").classList.add("visually-hidden");
        else 
            node.querySelector("input").checked = is_selected;

        checkbox.value = contact.publicKey;

        styleAvatar(node.querySelector(".avatar"), { fullname: contact.userID[0], pgp_pubkey: contact.publicKey }, 36);
        node.querySelector(".name").textContent = contact.userID[0] + str_is_self;

        checkbox.addEventListener('change', async (ev) => {
            if (ev.target.type !== 'checkbox') return; // prevent default

            const result = [];
            var counter_selected_rcpts = 0;
            const contact_nodes = lstEndorseFieldset.children;
            for (const node_rcpt of contact_nodes)
                if (node_rcpt.querySelector("input").checked == true) {
                    counter_selected_rcpts++;
                    const node_pk = await get_pub_key(node_rcpt.querySelector("input").value);
                    result.push({
                        username: node_pk.myKeyPairUserID[0],
                        pubkey: node_rcpt.querySelector("input").value,
                    })
                }

            root.querySelector(".selected_participants").innerText = counter_selected_rcpts

            quorumSlider.min = 2;
            quorumSlider.max = counter_selected_rcpts;

            quorumNumber.innerText = quorumSlider.value;

            MsgComposeModule.set_threshold(quorumSlider.value);

            show_hide_quorum_panel(counter_selected_rcpts);

            if (is_access_method_single)
                bootstrap.Offcanvas.getOrCreateInstance(root.querySelector(".offcanvas")).hide()

            if (!is_access_method_quorum || result.length >= 2)
                MsgComposeModule.add_recipient(result);
            else
                MsgComposeModule.add_recipient([]);

        })

        lstEndorseFieldset.appendChild(node);
    }

    //const partecipants = users.filter(x => endorsements[x.pgp_pubkey] === u.pgp_pubkey);

}

// -------------------------------------------------------------------------------------------
function show_hide_quorum_panel(num_recipients) {

    if (is_access_method_quorum != true) {
        root.querySelector(".quorum_panel").classList.add("d-none");
        root.querySelector(".quorum_not_enough_participants").classList.add("d-none");
        return;
    }

    // is_access_method_quorum is true

    if (num_recipients >= 2) {
        root.querySelector(".quorum_panel").classList.remove("d-none");
        root.querySelector(".quorum_not_enough_participants").classList.add("d-none");
    }
    else {
        root.querySelector(".quorum_panel").classList.add("d-none");
        root.querySelector(".quorum_not_enough_participants").classList.remove("d-none");
    }
}